import { Box, Drawer, IconButton } from '@mui/material'
import React from 'react'

import { ArrowRight, LeftArrow } from '../../../assets/icons'

export interface SideBarProps {
  open: boolean
  setOpen: (open: boolean) => void
  children?: React.ReactNode
  openIcon?: React.ReactNode
  closeIcon?: React.ReactNode
  drawerWidth?: number
  drawerWidthClosed?: number
  // Verschiebung nach rechts bzw. Höhenreduktion, wenn ein anderes fixes
  // Element (z.B. der KI-Chat-Drawer im Push-Modus) Platz beansprucht.
  offsetLeft?: number
  heightOffset?: number
}

const SideBar: React.FC<SideBarProps> = ({
  children,
  closeIcon,
  openIcon,
  open,
  setOpen,
  drawerWidth = 380,
  drawerWidthClosed = 90,
  offsetLeft = 0,
  heightOffset = 0
}) => {
  const childrenWithProps = React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { open } as { open: boolean })
    }
    return child
  })

  const handleDrawer = () => {
    setOpen(!open)
  }

  return (
    <Box>
      <Drawer
        variant="permanent"
        sx={{
          '& .MuiDrawer-paper': {
            overflow: 'hidden',
            left: `${offsetLeft}px`,
            height: heightOffset ? `calc(100% - ${heightOffset}px)` : '100%',
            transition: theme => theme.transitions.create(['left', 'height'])
          }
        }}
      >
        <IconButton
          aria-label="open drawer"
          onClick={handleDrawer}
          edge="start"
          sx={{
            zIndex: 981,
            position: 'fixed',
            top: '186px',
            left: `${(open ? drawerWidth - 16 : drawerWidthClosed - 16) + offsetLeft}px`,
            color: 'inherit',
            transition: theme => theme.transitions.create('left')
          }}
          size="large"
        >
          {open ? closeIcon || <LeftArrow /> : openIcon || <ArrowRight />}
        </IconButton>
        <Box
          sx={{
            position: 'relative',
            flex: 1,
            whiteSpace: 'nowrap',
            width: open ? `${drawerWidth}` : `${drawerWidthClosed}`,
            backgroundColor: 'petrol',
            overflowY: 'hidden',
            height: '100%'
          }}
        >
          {childrenWithProps}
        </Box>
      </Drawer>
    </Box>
  )
}

export default SideBar
